import { render } from "./template.vue?vue&type=template&id=2b4338fe&scoped=true&lang=pug"
const script = {}

import "./template.vue?vue&type=style&index=0&id=2b4338fe&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4338fe"]])

export default __exports__